import React, { useState, useEffect } from "react";
import RoleToggle from "../../components/RoleToggle";
import UnifiedManifestTab from "./_components/UnifiedManifestTab";
import LocationTab from "../PickupManagement/_components/LocationTab";
import { usePermission } from "../../hooks/usePermissionTabs";

const ManifestManagement: React.FC = () => {
  const { allowed: canReadPickup } = usePermission("pickup_manifests", "read");
  const { allowed: canReadReturn } = usePermission("return_to_shipper", "read");
  const { allowed: canReadProduct } = usePermission("product_manifest", "read");
  const { allowed: canReadLocation } = usePermission("pickup_locations", "read");

  const visibleTabs = [
    ...(canReadPickup || canReadReturn || canReadProduct ? ["All Manifests"] : []),
    ...(canReadLocation ? ["Pickup Locations"] : []),
  ];

  const [activeTab, setActiveTab] = useState("");
  const [mainHeaderButtons, setMainHeaderButtons] = useState<React.ReactNode>(null);

  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.includes(activeTab)) {
      setActiveTab(visibleTabs[0]);
    }
  }, [visibleTabs, activeTab]);

  if (visibleTabs.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        You don't have access to this section
      </div>
    );
  }

  return (
    <div className="px-4 space-y-0" style={{ fontFamily: '"Inter Tight", sans-serif' }}>
      {/* Title & Tabs row */}
      <div className="flex justify-between items-center pr-3">
        {visibleTabs.length > 0 && (
          <RoleToggle
            options={visibleTabs}
            active={activeTab}
            onChange={(tab: any) => {
              setActiveTab(tab);
            }}
            containerClassName="inline-flex rounded-t-lg rounded-tr-[20px] bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 py-0.5 px-1 overflow-x-auto hide-scrollbar max-w-full relative"
            activeClassName="bg-[#000] text-[#FFFFFF] font-bold shadow-sm"
            inactiveClassName="bg-transparent text-[#212121]/70 font-bold"
          />
        )}
        {mainHeaderButtons}
      </div>

      {/* Tab content */}
      <div className="mt-0">
        {activeTab === "All Manifests" && (
          <UnifiedManifestTab setHeaderButtons={setMainHeaderButtons} />
        )}
        {activeTab === "Pickup Locations" && (
          <LocationTab setHeaderButtons={setMainHeaderButtons} />
        )}
      </div>
    </div>
  );
};

export default ManifestManagement;
